<template>
	<div class="userstoreTab">
		<div  class="userstoreTab_box">
            <div style="font-size:18px;padding:2px 0">{{$t('storeManagement.opmngh')}}</div>
			<el-tabs v-model="this.$route.path"  @tab-click="handleClick">
			   <el-tab-pane 
			   v-for="item in tabs"
			   :key="item.name"
			   :label="item.label"
			   :name="item.name"
			   >
			   </el-tab-pane>
			</el-tabs>	
		</div>
		<div>
			 <router-view></router-view>
		</div>
	</div>
</template>

<script>
import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default{
		data(){
			return {
				activeIndex:null,
				tabs: [
				  { label: this.$t('storeManagement.ijkj'), name: "/storeManagement/single",},
				  { label: this.$t('storeManagement.oikl'), name: "/storeManagement/combination",},
                  { label: this.$t('storeManagement.ppki'), name: "/storeManagement/gift",}
				  
				],
			}
    },
    computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userName: state => state.shopaccess.userInfo.userName,
			
				
			}),
		},  
		created(){
			// this.init()

		},
		
		methods: {
			init(){
				this.activeIndex=this.tabs[0].name
			},
			
			handleClick(tab, event,name) {
				this.$router.push({path:tab.name})
			},
		}
		
	}
</script>

<style >
	/* .userstoreTab{
		flex: 1;
        margin: 60px 0 0 223px;
	} */

    .userstoreTab .userstoreTab_box{
    
    position: fixed;
    top:50px;
    z-index: 6;
    width: 100%;
    padding: 10px 10px;
    background-color: #fff;

    
    }

    .el-tabs__item{
        font-size: 18px!important;
    }

	
	
</style>
